import React from 'react';
import cn from '@/utils/cn';
import { IconProps } from '@/components/Icons/types/IconInterface';

export interface TTabItem<TTabId extends string = string> {
  id: TTabId;
  label: string;
  Icon: React.ComponentType<IconProps>;
}

interface TabsProps<TTabId extends string> {
  tabs: TTabItem<TTabId>[];
  activeTab: TTabId;
  onChange: (tab: TTabId) => void;
}

const Tabs = <TTabId extends string>({ tabs, activeTab, onChange }: TabsProps<TTabId>) => (
  <div
    className="overflow-hidden inline-flex border-t border-r border-aux-gray rounded-tr-lg"
    role="tablist">
    {tabs.map(({ id, label, Icon }, index) => {
      const isActive = activeTab === id;
      return (
        <React.Fragment key={id}>
          {index > 0 && <div className="w-px bg-aux-gray self-stretch" />}
          <button
            type="button"
            onClick={() => onChange(id)}
            className={cn(
              'flex items-center justify-center gap-2 min-w-[246px] px-4 py-3 text-sm font-medium transition-colors',
              isActive
                ? 'bg-emerge-teal text-emerge-navy'
                : 'bg-emerge-base-3 text-emerge-navy-2 hover:text-emerge-navy'
            )}
            aria-selected={isActive}
            role="tab"
            aria-label={label}>
            <Icon size="xs" />
            {label}
          </button>
        </React.Fragment>
      );
    })}
  </div>
);

export default Tabs;
